import React, { Component, PropTypes } from 'react';
import AlertIcon from '../ErrorMessage/Alert';
import {
  StyledErrorMessage,
  StyledErrorTitleText,
  StyledErrorHeading,
  StyledErrorContent,
  StyledErrorLink
} from './styles';

/**
 * Error Message appears on the screen when an Error is detected and needs to be displayed to the
 * user, such as in cases where there is no data for offers or incentives.
 */
class ErrorMessage extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    errorColor: PropTypes.string,
    linkURL: PropTypes.string,
    linkText: PropTypes.string
  };
  static defaultProps = {
    errorColor: '',
    linkText: '',
    linkURL: ''
  };
  render() {
    const { title, message, errorColor, linkText, linkURL } = this.props;
    const link = linkText && linkURL ? <StyledErrorLink className="contact-dealer" href={linkURL}>{linkText}</StyledErrorLink> : '';
    return (
      <StyledErrorMessage className="payment-estimator-error">
        <StyledErrorHeading className="heading-third error-title"> <AlertIcon scale={1} color={errorColor} /> <StyledErrorTitleText>{title}</StyledErrorTitleText> </StyledErrorHeading>
        <StyledErrorContent className="arial-text">{message}</StyledErrorContent>
        {link}
      </StyledErrorMessage>
    );
  }
}

export default ErrorMessage;



/** WEBPACK FOOTER **
 ** ./src/components/ErrorMessage/index.js
 **/